module.exports = __webpack_public_path__ + "img/chunni02.31410221.jpg";